import LegalLayout from "./LegalLayout";
import { GraduationCap, LineChart, Users, Target } from "lucide-react";

export default function WhatWeProvidePage() {
  const items = [
    {
      icon: GraduationCap,
      title: "Educational Masterclass / Webinars",
      desc: "Free and paid live sessions focused on market structure, price-action concepts, time-based analysis, and analytical frameworks to help traders study market behaviour more systematically.",
    },
    {
      icon: LineChart,
      title: "Market Analysis Content",
      desc: "Educational commentary on index levels, price action, and broader market structure — shared for study and discussion purposes, not as trade calls or recommendations.",
    },
    {
      icon: Target,
      title: "Trading System Frameworks",
      desc: "Structured approaches to entry, exit, and risk management — taught as concepts for you to study, back-test, and adapt to your own judgement and discipline.",
    },
    {
      icon: Users,
      title: "Community Learning",
      desc: "A free Telegram community where we occasionally share educational observations, important time windows, and market-structure discussion. Participation is entirely optional.",
    },
  ];

  return (
    <LegalLayout title="What We Provide">
      <p>
        VEE Consultancy is a <strong>market education initiative</strong>. Our goal is to help retail traders build a structured, rules-first understanding of how financial markets move — so that decision-making can be more disciplined and informed.
      </p>
      <p>
        We are <strong>not a SEBI-registered Investment Advisor or Research Analyst</strong>. Nothing we share constitutes investment advice, stock tips, or trading recommendations.
      </p>

      <div className="not-prose grid md:grid-cols-2 gap-5 my-10">
        {items.map((it, i) => (
          <div
            key={i}
            className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6 hover:border-emerald-500/30 transition-colors"
          >
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center mb-4 shadow-[0_6px_20px_rgba(16,185,129,0.3)]">
              <it.icon className="w-5 h-5 text-white" />
            </div>
            <h3 className="font-display text-lg text-white mb-2">{it.title}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{it.desc}</p>
          </div>
        ))}
      </div>

      <h2 className="text-2xl font-bold mt-10 mb-3">What We Do NOT Provide</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>We do not provide buy/sell calls, tips, or trade signals.</li>
        <li>We do not manage portfolios or handle client funds in any form.</li>
        <li>We do not promise or guarantee any specific returns, outcomes, or "sure-shot" profits.</li>
        <li>We do not provide personalized investment advice.</li>
      </ul>

      <h2 className="text-2xl font-bold mt-10 mb-3">Our Approach</h2>
      <p>
        <em>"Rules पहले, emotions बाद में."</em> — Everything we teach is built around a simple philosophy: systematic learning beats random decision-making. Our content is designed for serious learners who want to understand markets more deeply, not chase hype.
      </p>
    </LegalLayout>
  );
}
